import React from "react";

import Chip from "./index";

export default function EmployeeNumber({ isMe, ...props }) {
  const tooltip = `${isMe ? "Your" : "The talents"} employee number`;

  return <Chip monospace tooltip={tooltip} {...props} />;
}
